

 import img1 from "../../assets/Rectangle16.png"
import img2 from "../../assets/Rectangle19.png"
import img3 from "../../assets/Rectangle29.png"
import img4 from "../../assets/Rectangle26.png" 


export const collec = [
    {
      title: "Limits",
      artist: "john  doe",
      img: img1,
      likes: "2.3M",
    },
    {
        title: "Limits",
        artist: "john  doe",
        img: img2,
        likes: "2.3M",
      },
      {
        title: "Limits",
        artist: "john  doe",
        img: img3 ,
        likes: "2.3M",
      },
      {
        title: "Limits",
        artist: "john  doe",
        img: img4,
        likes: "2.3M",
      },
      
 
  ];
  